import { render, staticRenderFns } from "./template14.vue?vue&type=template&id=54550dd4&scoped=true"
import script from "./template14.vue?vue&type=script&lang=js"
export * from "./template14.vue?vue&type=script&lang=js"
import style0 from "./template14.vue?vue&type=style&index=0&id=54550dd4&prod&scoped=true&lang=scss"
import style1 from "./template14.vue?vue&type=style&index=1&id=54550dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54550dd4",
  null
  
)

export default component.exports